// extracted by mini-css-extract-plugin
export default {"form":"Input_form__OUPdR","input":"Input_input__xQIpv"};